function equalHeight(group) {
    var tallest = 0;
    group.each(function () {
        var thisHeight = $(this).height();
        if (thisHeight > tallest) {
            tallest = thisHeight;
  console.log('tallest: '+tallest);
        }
    });
    group.height(tallest);
}



function mobileViewUpdate() {
    var viewportWidth = $(window).width();
    if (viewportWidth >= 980) {
        $("body").addClass("desktop");
    } else if (viewportWidth >= 300) {
        $("body").addClass("tablet");
    } else {
        $("body").addClass("mobile");
    }
}



$( window ).load(function() {

mobileViewUpdate();

 
$('body.desktop .customEqual4').each(function() {
  obj = $(this);
  var length = obj.children().length;
  
  for (i = 0; i <= length; i += 4) {
    equalHeight($('> :nth-child('+(i+1)+'), > :nth-child('+(i+2)+'), > :nth-child('+(i+3)+'), > :nth-child('+(i+4)+')', obj));
  }
  
});

  
  
$('body.tablet .customEqual2, body.mobile .customEqual2').each(function() {
  obj = $(this);
  var length = obj.children().length;
  
  for (i = 0; i <= length; i += 2) {
    equalHeight($('> :nth-child('+(i+1)+'), > :nth-child('+(i+2)+')', obj));
  }
  
});
});
  
  
  
